import {Alert, useOpenModal} from '@/components/Modal/index.mjs'
import openWindow from '@/script/openWindow.mjs'
import {useMapContext} from '@/components/MindMap/index.mjs'
import metaBizNode from '../../metaBizNode.mjs'

export default () => {
    const openModal = useOpenModal()
    const map = useMapContext()
    const {mapTypeCode, subTypeCode} = map.data

    if (! (
        'BODA2' === subTypeCode &&
        'SA_MAP' === mapTypeCode
    )) {
        return null
    }

    const onClick = async () => {
        const {name, textProp} = metaBizNode.FM
        const fmIds = []
        const fmNames = []

        for (const n of map.selectedNodes) {
            const {bizNodeType, pkid, [textProp]: text} = n.data

            if ('FM' === bizNodeType) {
                fmIds.push(pkid)
                fmNames.push(text)
            }
        }

        if (0 === fmIds.length) {
            await openModal(
                <Alert type="error">未选择{name}</Alert>
            )

            return
        }

        const {prjId, sVer} = map.data

        openWindow(
            '/Ai',

            {
                bizMap: {fmIds, prjId, sVer},
                prjId,
                scene: 'GENERATE_USPEC',
                sVer,
                title: `${name}: ${fmNames.join(', ')}`,
            }
        )
    }

    return {
        label: '界面验收标准逆向',
        onClick,
    }
}
